import { CheckCircle2 } from "lucide-react";
import { cn } from "@/lib/utils";

/** Green tick badge shown on lawyers who offer online / remote guidance. */
export function OnlineBadge({ lang = "en", size = "sm", className }) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-emerald-300 bg-emerald-50 font-semibold text-emerald-700 dark:border-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300",
        size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-[11px]",
        className,
      )}
      data-testid="online-guidance-badge"
    >
      <CheckCircle2 className={size === "lg" ? "h-4 w-4" : "h-3.5 w-3.5"} />
      {lang === "hi" ? "ऑनलाइन मार्गदर्शन उपलब्ध" : "Available for Online Guidance"}
    </span>
  );
}

export default OnlineBadge;
